import { useEffect, useState } from "react";

/**
 * Valor que só se propaga depois de `ms` sem mudar.
 *
 * Usado no cabeçalho de custos da importação: cada tecla ali refaz o rateio de
 * TODOS os itens, e numa NF-e de cem linhas isso trava o campo enquanto se
 * digita. O input responde na hora (estado próprio) e o recálculo espera a
 * pessoa parar.
 */
export default function useDebounced(value, ms = 150) {
  const [atrasado, setAtrasado] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setAtrasado(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);

  return atrasado;
}
